import { ORGX_HOSTED_MCP_URL } from "../constants.js";
import {
  resolveOrgxAuth,
  type OrgxAuthSource,
  type ResolveOrgxAuthOptions,
} from "./auth.js";

const DEFAULT_TOOL_NAME = "get_setup_status";

export interface HostedMcpToolCheck {
  configured: boolean;
  ok: boolean;
  skipped: boolean;
  source: OrgxAuthSource | "none";
  toolName: string;
  url: string;
  baseUrl?: string;
  initializeStatus?: number;
  callStatus?: number;
  error?: string;
  details: string[];
  response?: unknown;
}

export async function checkHostedMcpToolAccess(
  options: ResolveOrgxAuthOptions = {},
  toolName = DEFAULT_TOOL_NAME,
): Promise<HostedMcpToolCheck> {
  const auth = await resolveOrgxAuth(options);
  if (!auth) {
    return {
      configured: false,
      ok: false,
      skipped: true,
      source: "none",
      toolName,
      url: ORGX_HOSTED_MCP_URL,
      error: "No OrgX API key configured; hosted MCP tool verification skipped.",
      details: [],
    };
  }

  return {
    configured: true,
    ok: false,
    skipped: true,
    source: auth.source,
    toolName,
    url: ORGX_HOSTED_MCP_URL,
    baseUrl: auth.baseUrl,
    error: "Hosted OrgX MCP uses OAuth; API-key tool verification is skipped.",
    details: [
      `auth source: ${auth.source}`,
      "Hosted OrgX MCP connectors complete OAuth during client setup, so the wizard cannot preflight tools with an oxk_ API key.",
    ],
  };
}
